    $(function() {
		const swiper = new Swiper(".swiper", {
		  loop: true, // ループ有効
		  loopedSlides:8,
		  slidesPerView: 'auto',
		  speed: 11000, // ループの時間
		  allowTouchMove: false, // スワイプ無効
		  autoplay: {
		    delay: 0, // 途切れなくループ
		  },
		});
	})
